// extracted by mini-css-extract-plugin
export default {"Checkbox":"f52b3a253b40"};